export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  } else {
    return text.substring(0, maxLength) + '...';
  }
};

export const capitalizeFirstLetter = (str) => {
  if (!str) {
    return str;
  }

  // If the string is all uppercase, parse to lowercase
  if (allUppercase(str)) {
    let lowerCaseTitle = str.toLowerCase();
    lowerCaseTitle = lowerCaseTitle.replace(/&amp;/g, '&');
    return lowerCaseTitle.charAt(0).toUpperCase() + lowerCaseTitle.slice(1);
  }

  let cleanTitle = str.replace(/&amp;/g, '&');
  return cleanTitle;
};

export const allUppercase = (sentence) => {
  return sentence.split(' ').every((word) => word === word.toUpperCase());
};

export const prepareQueryParam = (value) => {
  if (!value) return '';
  return value
    .toLowerCase()
    .replace(/\s+/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9-]/g, '');
};
